import { render } from "./import-system-from-zip-modal.vue?vue&type=template&id=335163ae&ts=true"
import script from "./import-system-from-zip-modal.vue?vue&type=script&lang=ts"
export * from "./import-system-from-zip-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__